// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SFmdypKOiyGnb4HYnQEj {
    color: #333;
    cursor: pointer;
    font-family: monospace;
    font-size: 12px;
    overflow: hidden;
    padding: 8px;
    text-overflow: ellipsis;
    user-select: none;
    white-space: nowrap;
    width: 260px;
}

.mZVl4qVeQgUnam4Wup24 {
    cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/admin/import/interest_imports/components/preview-value.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".value {\n    color: #333;\n    cursor: pointer;\n    font-family: monospace;\n    font-size: 12px;\n    overflow: hidden;\n    padding: 8px;\n    text-overflow: ellipsis;\n    user-select: none;\n    white-space: nowrap;\n    width: 260px;\n}\n\n.only {\n    cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"value": `SFmdypKOiyGnb4HYnQEj`,
	"only": `mZVl4qVeQgUnam4Wup24`
};
export default ___CSS_LOADER_EXPORT___;
